import { render, staticRenderFns } from "./CloneClientDlg.vue?vue&type=template&id=6c44dc56&"
import script from "./CloneClientDlg.vue?vue&type=script&lang=js&"
export * from "./CloneClientDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports